<template>
  <canvas :id="id" width="100" height="100"></canvas>
</template>

<script>
    import Chart from './chart'
    import {v4 as uuidv4} from 'uuid'

    export default {
        components: {},
        name: 'DoughnutChart',
        props: {
            title: {
                type: String,
                required: true
            },
            graphData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                id: '',
                chartData: {
                    type: 'doughnutLabels',
                    data: this.graphData,
                    options: {
                        circumference: 2 * Math.PI,
                        rotation: 2.0 * Math.PI,
                        responsive: true,
                        maintainAspectRatio: true,
                        fontSize: 20,
                        legend: {
                            position: 'top',
                            fontSize: 20
                        },
                        title: {
                            text: this.title,
                            display: false,
                            fontSize: 20
                        },
                        animation: {animateScale: true, animateRotate: true}
                    }
                }
            }
        },
        computed: {},
        methods: {
            createChart(chartId, chartData) {
                const ctx = document.getElementById(chartId)
                const myChart = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.options,
                })
                return myChart
            }
        },
        mounted() {
            this.id = uuidv4()
            this.$nextTick(() => {
                this.createChart(this.id, this.chartData)
            })
        }
    }
</script>